import axios from '@/utils/http'

// 获取基本面系统token
export const apiGetFDSToken = () => {
    const time = new Date().getTime()
    return axios.get('/getFDSToken', {params: {'t': time}})
}
